// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GlobalFooter_wrap_33qXc","top_img":"GlobalFooter_top_img_1nQQS","content":"GlobalFooter_content_2t9Vz","links":"GlobalFooter_links_3wnPs"};